import script from "./DateFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DateFilter.vue?vue&type=script&setup=true&lang=js"

import "./DateFilter.vue?vue&type=style&index=0&id=8807acf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8807acf6"]])

export default __exports__